/**
 * @generated SignedSource<<3906c6c4f65d873d7ce3973f8c186530>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailFramingOptions_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_item">;
  readonly " $fragmentType": "PdpSharedDetailFramingOptions_item";
};
export type PdpSharedDetailFramingOptions_item$key = {
  readonly " $data"?: PdpSharedDetailFramingOptions_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailFramingOptions_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailFramingOptions_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "49d0f6230269b3ea24a96b9d382155b5";

export default node;
